import { tryCatch } from '@/services/api-client';
import { dataProvider } from '@/services/data-provider';
import { GetListParams } from '../common/common.types';
import {
  CreateOrganizationBody,
  Organization,
  UpdateOrganizationBody,
} from './organizations.types';

export const getOrganizationsList = async ({
  filter,
  sort,
  order,
  perPage,
  page,
}: GetListParams) => {
  const { data: response, error } = await tryCatch(
    dataProvider.getList<Organization>('organisations', {
      pagination: { page: page || 1, perPage: perPage || 10 },
      sort: { field: sort || 'updated_at', order: order || 'DESC' },
      filter,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const getOrganization = async (id: string) => {
  const { data: response, error } = await tryCatch(
    dataProvider.getOne<Organization>('organisations', { id }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const createOrganization = async (data: CreateOrganizationBody) => {
  const { data: response, error } = await tryCatch(
    dataProvider.create<Organization>('organisations', {
      data,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const updateOrganization = async (
  id: string,
  data: UpdateOrganizationBody,
) => {
  const { data: response, error } = await tryCatch(
    dataProvider.update<Organization>('organisations', {
      id,
      data,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};
